<script lang="jsx">
  import { h as createElement } from 'vue'
  import {
    get, set, orderBy, includes, forEach, find, size,
    cloneDeep, forIn,
  } from 'lodash'
  import SortCell from './components/SortCell.vue'
  import YamBTable from './BaseTable.vue'

  const SLOT_HEAD_NAME = 'sortThead'
  export const ASC = 'asc'
  export const DESC = 'desc'
  export const DEFAULT_SORT = ASC
  let lastAsyncData

  export default {
    components: {
      YamBTable,
    },
    props: {
      ...YamBTable.props,
      defaultSort: {
        type: Object,
        default: () => ({}),
      },
      multipleSort: {
        type: Boolean,
        default: false,
      },
      async: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        filters: {},
        sortData: this.data,
      }
    },
    watch: {
      columns: {
        handler() {
          this.columns.forEach(item => {
            if (includes([true], item.sort)) {
              set(item, 'th.is', SLOT_HEAD_NAME)
            }
          })
        },
        deep: true,
        immediate: true,
      },
      data: {
        handler(value) {
          if (!size(value) > 0) {
            this.sortData = value
            return
          }
          this.initSort(value)
        },
        deep: true,
        immediate: true,
      },
    },
    created() {
      if (this.async === true) {
        this.setDefaultFilters()
      }
    },
    methods: {
      resetFilters() {
        this.filters = {}
      },
      initSort(initAsyncData) {
        // 异步获取到新数据
        if (this.async === true) {
          this.sortData = initAsyncData
        } else {
          lastAsyncData = cloneDeep(initAsyncData)
          this.resetFilters()
          this.setDefaultFilters()
          forIn(this.filters, (order, key) => {
            const sortInfo = find(this.columns, { key })
            const sortFn = get(sortInfo, 'sortFn')
            this.sort({
              key,
              order,
              sortFn,
            })
          })
        }
      },
      setDefaultFilters() {
        const {
          keys = [],
          orders = ASC,
        } = this.defaultSort

        forEach(keys, (key, index) => {
          const order = get(orders, `[${index}]`)
          this.refreshFilters(key, order)
        })
      },
      refreshFilters(key, order) {
        if (order === this.filters[key]) {
          delete this.filters[key]
        } else if (this.multipleSort === true) {
          this.filters[key] = order
        } else {
          this.filters = {}
          this.filters[key] = order
        }
      },
      sort({
        key,
        order = DEFAULT_SORT,
        sortFn,
      }) {
        if (this.async === true) {
          // 后端排序
          this.$emit('on-change-filters', {
            key,
            order,
            filters: this.filters,
          })
          return
        }
        const sortKeys = Object.keys(this.filters)
        const sortRanks = Object.values(this.filters)
        const sortMethods = rowData => sortFn(rowData, order)
        if (size(sortKeys) > 0) {
          // 前端排序
          const afterSortData = sortFn ? orderBy(this.data, sortMethods) : orderBy(this.data, sortKeys, sortRanks)
          this.sortData = afterSortData
        } else {
          // 如果清空filters需要把数据还原到最后一次从服务器同步过来的数据
          this.sortData = lastAsyncData
        }
      },
    },
    render() {
      return createElement(
        YamBTable,
        {
          ...this.$props,
          data: this.sortData,
        },
        {
          [SLOT_HEAD_NAME]: props => {
            const { column } = props
            const key = get(column, 'key')
            const sortFn = get(column, 'sortFn')
            return (
              <div>
                <span>{column.title}</span>
                <SortCell
                  ascActive={this.filters[key] === ASC}
                  descActive={this.filters[key] === DESC}
                  onClickAsc={() => {
                    this.refreshFilters(key, ASC)
                    this.sort({
                      order: ASC,
                      key,
                      sortFn,
                    })
                  }}
                  onClickDesc={() => {
                    this.refreshFilters(key, DESC)
                    this.sort({
                      order: DESC,
                      key,
                      sortFn,
                    })
                  }}
                >
                </SortCell>
              </div>
          )
          },
          ...this.$slots,
        },
      )
    },
  }
</script>
